import { render, staticRenderFns } from "./LogoLink.vue?vue&type=template&id=46d3c99b&scoped=true&"
import script from "./LogoLink.vue?vue&type=script&lang=js&"
export * from "./LogoLink.vue?vue&type=script&lang=js&"
import style0 from "./LogoLink.vue?vue&type=style&index=0&id=46d3c99b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d3c99b",
  null
  
)

export default component.exports